/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusHistoryItem
 */
export interface BonusHistoryItem {
    /**
     * 流水ID
     * @type {number}
     * @memberof BonusHistoryItem
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusHistoryItem
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof BonusHistoryItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof BonusHistoryItem
     */
    userCode?: string;
    /**
     * 使用区分：1-管理员发放，2-支付账单使用，3-账单退款回退，4-取消支付回退，5-管理员扣减，6-赠送金冻结，7-赠送金解冻
     * @type {number}
     * @memberof BonusHistoryItem
     */
    type?: number;
    /**
     * 使用区分名称
     * @type {string}
     * @memberof BonusHistoryItem
     */
    typeName?: string;
    /**
     * 发放来源：1-赔偿金，2-充值赠送，3-活动赠送（仅type=1时有值）
     * @type {number}
     * @memberof BonusHistoryItem
     */
    source?: number;
    /**
     * 发放来源名称
     * @type {string}
     * @memberof BonusHistoryItem
     */
    sourceName?: string;
    /**
     * 金额（恒为正数，方向由type表达：2/5为支出、6为余额转冻结、7为冻结转回，配对同额；前端按type渲染正负）
     * @type {number}
     * @memberof BonusHistoryItem
     */
    amount?: number;
    /**
     * 操作后可用余额（净额模型快照：冻结减、解冻加、收支随资金方向，天然连贯）
     * @type {number}
     * @memberof BonusHistoryItem
     */
    balanceAfter?: number;
    /**
     * 内容（备注）
     * @type {string}
     * @memberof BonusHistoryItem
     */
    remark?: string;
    /**
     * 关联支付单ID（type=2/3/4/6/7时关联，合单场景取父单id；type=1/5无支付单为null）
     * @type {number}
     * @memberof BonusHistoryItem
     */
    paymentId?: number;
    /**
     * 流水日期
     * @type {string}
     * @memberof BonusHistoryItem
     */
    createTime?: string;
}

/**
 * Check if a given object implements the BonusHistoryItem interface.
 */
export function instanceOfBonusHistoryItem(value: object): value is BonusHistoryItem {
    return true;
}

export function BonusHistoryItemFromJSON(json: any): BonusHistoryItem {
    return BonusHistoryItemFromJSONTyped(json, false);
}

export function BonusHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'balanceAfter': json['balanceAfter'] == null ? undefined : json['balanceAfter'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'paymentId': json['paymentId'] == null ? undefined : json['paymentId'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function BonusHistoryItemToJSON(json: any): BonusHistoryItem {
    return BonusHistoryItemToJSONTyped(json, false);
}

export function BonusHistoryItemToJSONTyped(value?: BonusHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'type': value['type'],
        'typeName': value['typeName'],
        'source': value['source'],
        'sourceName': value['sourceName'],
        'amount': value['amount'],
        'balanceAfter': value['balanceAfter'],
        'remark': value['remark'],
        'paymentId': value['paymentId'],
        'createTime': value['createTime'],
    };
}

